export const dosageOptions = [
  {
    value: "50 mcg",
    label: "50 mcg",
  },
  {
    value: "100 mcg",
    label: "100 mcg",
  },
  {
    value: "250 mcg",
    label: "250 mcg",
  },
  {
    value: "500 mcg",
    label: "500 mcg",
  },
  {
    value: "1,000 mcg",
    label: "1,000 mcg",
  },
  {
    value: "1 mg",
    label: "1 mg",
  },
  {
    value: "2 mg",
    label: "2 mg",
  },
  {
    value: "5 mg",
    label: "5 mg",
  },
  {
    value: "10 mg",
    label: "10 mg",
  },
  {
    value: "25 mg",
    label: "25 mg",
  },
  {
    value: "50 mg",
    label: "50 mg",
  },
  {
    value: "75 mg",
    label: "75 mg",
  },
  {
    value: "100 mg",
    label: "100 mg",
  },
  {
    value: "250 mg",
    label: "250 mg",
  },
  {
    value: "500 mg",
    label: "500 mg",
  },
  {
    value: "750 mg",
    label: "750 mg",
  },
  {
    value: "1,000 mg",
    label: "1,000 mg",
  },
  {
    value: "1 g",
    label: "1 g",
  },
  {
    value: "2 g",
    label: "2 g",
  },
  {
    value: "5 g",
    label: "5 g",
  },
  {
    value: "10 g",
    label: "10 g",
  },
  {
    value: "20 g",
    label: "20 g",
  },
  {
    value: "50 g",
    label: "50 g",
  },
  {
    value: "0.5 mL",
    label: "0.5 mL",
  },
  {
    value: "1 mL",
    label: "1 mL",
  },
  {
    value: "2 mL",
    label: "2 mL",
  },
  {
    value: "5 mL",
    label: "5 mL",
  },
  {
    value: "10 mL",
    label: "10 mL",
  },
  {
    value: "20 mL",
    label: "20 mL",
  },
  {
    value: "50 mL",
    label: "50 mL",
  },
  {
    value: "100 mL",
    label: "100 mL",
  },
  {
    value: "250 mL",
    label: "250 mL",
  },
  {
    value: "500 mL",
    label: "500 mL",
  },
  {
    value: "1,000 mL",
    label: "1,000 mL",
  },
  {
    value: "Other",
    label: "Other",
  },
];

export const quantityOptions = [
  {
    value: "1/4 tablet",
    label: "1/4 tablet",
  },
  {
    value: "1/2 tablet",
    label: "1/2 tablet",
  },
  {
    value: "1 tablet",
    label: "1 tablet",
  },
  {
    value: "1 1/2 tablets",
    label: "1 1/2 tablets",
  },
  {
    value: "2 tablets",
    label: "2 tablets",
  },
  {
    value: "3 tablets",
    label: "3 tablets",
  },
  {
    value: "4 tablets",
    label: "4 tablets",
  },
  {
    value: "5 tablets",
    label: "5 tablets",
  },
  {
    value: "1 capsule",
    label: "1 capsule",
  },
  {
    value: "2 capsules",
    label: "2 capsules",
  },
  {
    value: "3 capsules",
    label: "3 capsules",
  },
  {
    value: "1 suppository",
    label: "1 suppository",
  },
  {
    value: "2 suppositories",
    label: "2 suppositories",
  },
  {
    value: "1 lozenge",
    label: "1 lozenge",
  },
  {
    value: "2 lozenges",
    label: "2 lozenges",
  },
  {
    value: "1 sachet",
    label: "1 sachet",
  },
  {
    value: "2 sachets",
    label: "2 sachets",
  },
  {
    value: "1 puff",
    label: "1 puff",
  },
  {
    value: "2 puffs",
    label: "2 puffs",
  },
  {
    value: "3 puffs",
    label: "3 puffs",
  },
  {
    value: "4 puffs",
    label: "4 puffs",
  },
  {
    value: "5 puffs",
    label: "5 puffs",
  },
  {
    value: "As prescribed",
    label: "As prescribed",
  },
];

export const formOptions = [
  { value: "Tablet", label: "Tablet" },
  { value: "Capsule", label: "Capsule" },
  { value: "Caplet", label: "Caplet" },
  { value: "Liquid", label: "Liquid" },
  { value: "Syrup", label: "Syrup" },
  { value: "Suspension", label: "Suspension" },
  { value: "Solution", label: "Solution" },
  { value: "Injection", label: "Injection" },
  { value: "Cream", label: "Cream" },
  { value: "Ointment", label: "Ointment" },
  { value: "Gel", label: "Gel" },
  { value: "Lotion", label: "Lotion" },
  { value: "Patch (Transdermal)", label: "Patch (Transdermal)" },
  { value: "Suppository", label: "Suppository" },
  { value: "Pessary", label: "Pessary" },
  { value: "Inhaler", label: "Inhaler" },
  { value: "Nebuliser Solution", label: "Nebuliser Solution" },
  { value: "Eye Drops", label: "Eye Drops" },
  { value: "Ear Drops", label: "Ear Drops" },
  { value: "Nasal Spray", label: "Nasal Spray" },
  { value: "Mouthwash", label: "Mouthwash" },
  { value: "Powder", label: "Powder" },
  { value: "Granules", label: "Granules" },
  { value: "Spray", label: "Spray" },
  { value: "Foam", label: "Foam" },
  { value: "Drops", label: "Drops" },
  { value: "Lozenge", label: "Lozenge" },
  { value: "Chewable Tablet", label: "Chewable Tablet" },
  { value: "Dispersible Tablet", label: "Dispersible Tablet" },
  { value: "Soluble Tablet", label: "Soluble Tablet" },
  { value: "Buccal Film", label: "Buccal Film" },
  { value: "Sublingual Tablet", label: "Sublingual Tablet" },
  { value: "Enema", label: "Enema" },
  { value: "As prescribed", label: "As prescribed" },
];

export const adminTypeOptions = [
  { value: "Administered", label: "Administered" },
  { value: "Prompted", label: "Prompted" },
  { value: "Declined", label: "Declined" },
  { value: "Assisted", label: "Assisted" },
  { value: "Required", label: "Required" },
  { value: "Applied", label: "Applied" },
  { value: "As prescribed", label: "As prescribed" },
  { value: "Not Applicable", label: "Not Applicable" },
];

export const routeOptions = [
  { value: "Oral", label: "Oral" },
  { value: "Sublingual", label: "Sublingual" },
  { value: "Buccal", label: "Buccal" },
  { value: "Topical", label: "Topical" },
  { value: "Transdermal", label: "Transdermal" },
  { value: "Inhalation", label: "Inhalation" },
  { value: "Nasal", label: "Nasal" },
  { value: "Ophthalmic", label: "Ophthalmic" },
  { value: "Otic", label: "Otic" },
  { value: "Rectal", label: "Rectal" },
  { value: "Vaginal", label: "Vaginal" },
  { value: "As prescribed", label: "As prescribed" },
];
